module.exports = __webpack_public_path__ + "fonts/NotoSansGeorgian-Medium.26b3cd27.woff";